export default "__VITE_ASSET__DN8zqBs1__"